/* Mini match: show something when nothing matches.

   THE PROBLEM
   The set module pairs a frame with a kids frame of the same category. When
   no kids frame qualifies, the tab rendered "Nothing to pair here yet" — a
   dead end on a module whose whole purpose is to add a second item. A blank
   panel is worse than an imperfect suggestion: the shopper learns the tab
   is empty and stops opening it.

   WHAT THIS DOES
   When the Mini match tab comes up empty, it fills it with kids frames
   chosen at random from the catalogue already embedded in the page — IN
   STOCK ONLY, since offering a sold-out pair is worse than offering nothing.

   IT USES THE REAL MECHANISM, NOT A LOOKALIKE.
   Each row calls SF.pick(variantId, price, 'kid', title, image) — the same
   call the matched rows make — so a fallback pick joins the set, takes the
   ten percent add-on and enters the bag identically. Building link cards
   instead would have looked similar and quietly dropped the discount.

   THE PICKS ARE CHOSEN ONCE PER PAGE VIEW.
   The first version re-rolled them on every redraw, and the module redraws
   whenever anything is picked — so choosing a frame made that frame vanish
   and four different ones appear. The selection registered, but the shopper
   could not see what they had chosen. The list is now decided once and
   reused, and the chosen row is re-marked after each redraw so the tick
   survives.

   THE WORDING IS HONEST. These are not matches, so it says so rather than
   implying the frame was chosen to go with this one.

   WHY A SEPARATE FILE
   The renderer is minified into sf-claude.js. Watching for the empty state
   from outside is smaller than editing generated code, and if the renderer
   changes this stops finding the empty panel rather than breaking the module.
*/
(function(){
"use strict";

var HOW_MANY = 4;
var chosen = null;      /* decided once per page view */
var selected = {};      /* variant ids the shopper has picked here */

function data(){
  try { return JSON.parse(document.getElementById('sf-data').textContent) || {}; }
  catch(e){ return {}; }
}

/* Kids frames that are actually buyable, flattened out of the families. */
function kidsPool(){
  var d = data(), out = [];
  (d.families || []).forEach(function(fam){
    if(String(fam.types || '').indexOf('Kids') < 0) return;
    (fam.products || []).forEach(function(p){
      if(!p.available || !p.id) return;   /* never suggest a sold-out pair */
      out.push({ id:p.id, title:p.title, price:p.price, img:p.img });
    });
  });
  return out;
}

function sample(list, n){
  var copy = list.slice(), picked = [];
  while(copy.length && picked.length < n){
    picked.push(copy.splice(Math.floor(Math.random()*copy.length), 1)[0]);
  }
  return picked;
}

function money(cents){ return (cents/1000).toFixed(3) + ' KD'; }

function rowHTML(p){
  var on = selected[p.id] ? '1' : '0';
  var safeTitle = String(p.title).replace(/'/g, "\\'").replace(/"/g, '&quot;');
  return '<button class="arow" data-on="' + on + '" aria-pressed="' + (on === '1') + '" ' +
    'data-mini-id="' + p.id + '" ' +
    'onclick="SF.pick(' + p.id + ',' + p.price + ",'kid','" + safeTitle + "','" + (p.img||'') + "')\">" +
    '<img src="' + (p.img||'') + '" alt="">' +
    '<span class="m"><b>' + p.title + '</b><span>' + money(p.price) + '</span></span>' +
    '<span class="tick"><svg viewBox="0 0 24 24"><path d="m5 13 4 4L19 7"/></svg></span>' +
    '</button>';
}

function fill(){
  var mod = document.getElementById('setmod');
  if(!mod) return;
  var rows = mod.querySelector('.rows');
  if(!rows) return;

  /* Only a genuinely empty panel. */
  if(!rows.querySelector('.none')) return;

  /* The Mini match tab must be the visible one — accessories and caps use
     the same empty message and have their own catalogues. */
  var tabs = mod.querySelectorAll('.tab');
  if(tabs.length < 2 || tabs[1].getAttribute('aria-selected') !== 'true') return;

  if(!chosen){
    var pool = kidsPool();
    if(!pool.length) return;            /* nothing in stock: leave the message */
    chosen = sample(pool, HOW_MANY);
  }

  rows.innerHTML =
    '<p class="note" style="margin:0 0 10px">' +
      (document.documentElement.lang === 'ar'
        ? 'لا يوجد مقاس أطفال بنفس الفئة. هذه بعض نظارات الأطفال المتوفرة.'
        : 'No kids frame in this category. Here are some kids frames in stock.') +
    '</p>' + chosen.map(rowHTML).join('');
}

/* Remember what was picked here, so the tick survives the redraw that
   follows every pick. Capture phase: the row's own onclick runs after. */
document.addEventListener('click', function(e){
  var row = e.target.closest ? e.target.closest('[data-mini-id]') : null;
  if(!row) return;
  var id = row.getAttribute('data-mini-id');
  selected[id] = !selected[id];
}, true);

function watch(){
  var mod = document.getElementById('setmod');
  if(!mod) return;
  var queued = false;
  new MutationObserver(function(){
    if(queued) return;
    queued = true;
    requestAnimationFrame(function(){ queued = false; fill(); });
  }).observe(mod, { childList:true, subtree:true });
  fill();
}

if(document.readyState === 'complete') watch();
else window.addEventListener('load', watch);
})();